import React from 'react';
import PublicSurveyPageStyle from 'src/pages/PublicSurveyPage/PublicSurveyPage.styles';

const PublicSurveyLanguage = props => {
  const { availableLanguages = [], setSelectedLanguage, selectedLanguage, navigationButtonTranslations, onLanguageNext = () => {} } = props;

  const onChange = value => {
    setSelectedLanguage(value);
  };

  return (
    <PublicSurveyPageStyle.LanguageContainer items-center>
      <PublicSurveyPageStyle.LanguageContainer space-around>
        <PublicSurveyPageStyle.LanguageLabel>Select your preferred language:</PublicSurveyPageStyle.LanguageLabel>
        {availableLanguages?.map(language => (
          <PublicSurveyPageStyle.RadioGroupItemRow key={language.value}>
            <PublicSurveyPageStyle.RadioGroupItem>
              <PublicSurveyPageStyle.RadioGroupInput
                checked={selectedLanguage === language.value}
                name={'language'}
                onChange={() => onChange(language.value)}
                type="radio"
                value={language.value}
              />
              <PublicSurveyPageStyle.RadioGroupCircle />
              <PublicSurveyPageStyle.RadioGroupText>{language.label}</PublicSurveyPageStyle.RadioGroupText>
            </PublicSurveyPageStyle.RadioGroupItem>
          </PublicSurveyPageStyle.RadioGroupItemRow>
        ))}
      </PublicSurveyPageStyle.LanguageContainer>
      <PublicSurveyPageStyle.FooterButtonsWrapper>
      <PublicSurveyPageStyle.LanguageBtnContainer>
        <div>
          <PublicSurveyPageStyle.SurveyActionButton onClick={onLanguageNext}>
            {navigationButtonTranslations.start} <PublicSurveyPageStyle.SurveyActionLogo name="survey-next" />
          </PublicSurveyPageStyle.SurveyActionButton>
        </div>
      </PublicSurveyPageStyle.LanguageBtnContainer>
      </PublicSurveyPageStyle.FooterButtonsWrapper>
    </PublicSurveyPageStyle.LanguageContainer>
  );
};

export default React.memo(PublicSurveyLanguage);
